//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'errorusewechat',
  data () {
    return {
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/errorPage/notWechat.vue